interface Currency {
  displayName: string;
  numericCode: number;
  defaultFractionDigits: number;
  subUnit: number;
  symbolSpaced: boolean;
  symbolPosition: "after" | "before";
  symbol: string;
  isoCode: "ERN";
};

const ERN: Currency = Object.freeze({
  "displayName": "Eritrean Nakfa",
  "numericCode": 232,
  "defaultFractionDigits": 2,
  "subUnit": 100,
  "symbolSpaced": true,
  "symbolPosition": "after",
  "isoCode": "ERN",
  "symbol": "Nfk"
});

export { ERN };
